import { IoMdCalendar } from 'react-icons/io';

import global from '../../../styles/layout.module.scss';
import { formatDate } from '../../utils/dayjs';
import SidebarCMS from '../SidebarCMS/SidebarCMS';

import styles from './LayoutDynamic.module.scss';

function LayoutDynamicSingle({ data, categories, appLinks, categoryTitle, contentName }) {
  return (
    <section className={global.section}>
      <div className={global.container}>
        <div className={global.row}>
          <div className={styles.column}>
            {data.data.map(dataContent => (
              <div key={dataContent.uuid} className={styles.card}>
                {dataContent.fields.cover_image !== null && (
                  <div>
                    <img className={styles.img} src={dataContent.fields.cover_image.path} alt="Card cap" />
                  </div>
                )}
                <div className={styles.body}>
                  <h1 className={styles.title}>{dataContent.title}</h1>
                  <div className={styles.meta}>
                    <div className={styles.tags}>
                      <div className={styles.tagsInfo}>
                        <span>
                          <IoMdCalendar className={styles.calendarIcon} alt="εικονίδιο ημερομηνίας" />
                        </span>
                        <p>{formatDate(dataContent.ct, 'DD MMMM, YYYY')}</p>
                      </div>
                    </div>
                  </div>
                  <div
                    className={styles.text}
                    dangerouslySetInnerHTML={{
                      __html: dataContent.fields.content,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className={styles.aside}>
            <SidebarCMS
              categories={categories}
              appLinks={appLinks}
              contentName={contentName}
              categoryTitle={categoryTitle}
              isSingleNews
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default LayoutDynamicSingle;
